var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "var(--background-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5C10.3137 13.5 13 10.8137 13 7.5C13 4.18629 10.3137 1.5 7 1.5C3.68629 1.5 1 4.18629 1 7.5C1 10.8137 3.68629 13.5 7 13.5Z",
    fill: "var(--background-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 8.6619C7.24847 8.66282 7.48758 8.56746 7.6672 8.39584C7.84682 8.22423 7.95297 7.98971 7.96338 7.74151L8.1378 4.59124C8.1378 4.28949 8.01793 4.0001 7.80456 3.78673C7.59119 3.57336 7.3018 3.4535 7.00005 3.4535C6.6983 3.4535 6.40891 3.57336 6.19554 3.78673C5.98217 4.0001 5.8623 4.28949 5.8623 4.59124L6.03672 7.73078C6.04441 7.98087 6.14937 8.21809 6.32928 8.39199C6.50919 8.56588 6.74984 8.66272 7.00005 8.6619Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 9.31667C6.77491 9.31667 6.55483 9.38347 6.36767 9.50861C6.18051 9.63374 6.03469 9.81159 5.94865 10.0196C5.86262 10.2277 5.84025 10.4566 5.88436 10.6774C5.92848 10.8981 6.03711 11.1009 6.19649 11.2599C6.35588 11.4189 6.55886 11.527 6.77973 11.5706C7.00061 11.6142 7.22946 11.5913 7.43731 11.5048C7.64516 11.4183 7.82266 11.272 7.94735 11.0846C8.07205 10.8971 8.13833 10.6769 8.13779 10.4517C8.13708 10.1505 8.0169 9.86175 7.80361 9.64896C7.59032 9.43617 7.30133 9.31667 7.00005 9.31667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedIcon2);
export default __webpack_public_path__ + "static/media/red-icon-2.613df3f9743baed3973e4d34ce3901a8.svg";
export { ForwardRef as ReactComponent };